import React, { useState, useEffect } from 'react';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../Mensaje';
import Cargando from '../../../../../Cargando';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { FaEdit, FaTrash, FaKey, FaUserShield, FaPlus, FaSync, FaSearch, FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import CryptoJS from 'crypto-js';
import AuthUser from '../../../../../pageauth/AuthUser';

export const RW_Empleados = () => {
    require('../../Remotework.css?v=1.1.0');
    const { ObtenerEmpleadosAdmin, CrearEmpleado, ActualizarEmpleado, EliminarEmpleado, CambiarPasswordEmpleado, ObtenerEstaciones } = PuenteApi();
    const { StartCargando, StopCargando } = Cargando();
    const { getUser } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [empleadosUnificados, setEmpleadosUnificados] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showPassModal, setShowPassModal] = useState(false);
    const [showPermissionsModal, setShowPermissionsModal] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [busqueda, setBusqueda] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

    const [empleadoActual, setEmpleadoActual] = useState({
        id: "",
        nombre: "",
        cuil: "",
        estado_civil: "",
        tipo_contrato: "",
        art: "",
        fecha_ingreso: "",
        vencimiento_contrato: "",
        domicilio: "",
        codigo_postal: "",
        provincia: "",
        localidad: "",
        telefono: "",
        email: "",
        password: "",
        // Permissions
        permiso_playa_minimercado: false,
        permiso_facturar_vencidos: false,
        permiso_alta_moviles: false,
        permiso_reimpresion_cierre: false
    });

    const [passData, setPassData] = useState({
        empleado: null,
        password: ""
    });

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
    const currentUser = getUser();

    useEffect(() => {
        cargarEstaciones();
    }, []);

    const cargarEstaciones = async () => {
        const estacionesGuardadas = localStorage.getItem("estaciones");
        let listaEstaciones = [];

        if (estacionesGuardadas) {
            try {
                const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
                listaEstaciones = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                setEstaciones(listaEstaciones);
            } catch (error) {
                console.error("Error decrypting stations", error);
            }
        }

        if (listaEstaciones.length === 0) {
            StartCargando("Cargando estaciones...");
            const response = await ObtenerEstaciones();
            StopCargando();
            if (response) {
                setEstaciones(response);
                listaEstaciones = response;
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
            }
        }

        if (listaEstaciones.length > 0) {
            cargarEmpleadosDeTodas(listaEstaciones);
        }
    };

    const cargarEmpleadosDeTodas = async (listaEstaciones) => {
        StartCargando("Cargando empleados de todas las estaciones...");
        let todosLosEmpleados = [];

        for (const estacion of listaEstaciones) {
            const empleadosEstacion = await ObtenerEmpleadosAdmin(estacion.endpoint);
            if (empleadosEstacion) {
                const empleadosConEstacion = empleadosEstacion.map(e => ({ ...e, estacionId: estacion.id, estacionNombre: estacion.nombre }));
                todosLosEmpleados = [...todosLosEmpleados, ...empleadosConEstacion];
            }
        }
        StopCargando();
        unificarEmpleados(todosLosEmpleados, listaEstaciones);
    };

    const unificarEmpleados = (todosLosEmpleados, listaEstaciones) => {
        const mapaEmpleados = {};

        todosLosEmpleados.forEach(empleado => {
            // Use DNI as unique identifier since CUIL might be null for old records
            const uniqueKey = empleado.dni || empleado.cuil || empleado.email;

            if (!mapaEmpleados[uniqueKey]) {
                mapaEmpleados[uniqueKey] = {
                    ...empleado,
                    estacionesEncontradas: [empleado.estacionId],
                    datosPorEstacion: { [empleado.estacionId]: empleado }
                };
            } else {
                mapaEmpleados[uniqueKey].estacionesEncontradas.push(empleado.estacionId);
                mapaEmpleados[uniqueKey].datosPorEstacion[empleado.estacionId] = empleado;
            }
        });

        const empleadosFinales = Object.values(mapaEmpleados).map(empleado => {
            const faltanteEn = listaEstaciones.filter(e => !empleado.estacionesEncontradas.includes(e.id));
            return {
                ...empleado,
                faltanteEn: faltanteEn
            };
        });
        setEmpleadosUnificados(empleadosFinales);
    };

    const handleClose = () => {
        setShowModal(false);
        setEmpleadoActual({
            id: "", nombre: "", cuil: "", estado_civil: "", tipo_contrato: "", art: "", fecha_ingreso: "", vencimiento_contrato: "",
            domicilio: "", codigo_postal: "", provincia: "", localidad: "", telefono: "", email: "", password: "",
            permiso_playa_minimercado: false, permiso_facturar_vencidos: false, permiso_alta_moviles: false, permiso_reimpresion_cierre: false
        });
        setModoEdicion(false);
    };

    const handleShow = () => setShowModal(true);

    const handleGuardarEmpleado = async (e) => {
        e.preventDefault();
        StartCargando("Guardando...");

        const localStation = estaciones.find(e => e.local);
        const remoteStations = estaciones.filter(e => !e.local);

        let remoteSuccessCount = 0;
        let remoteErrors = [];

        // 1. Process Remote Stations
        for (const estacion of remoteStations) {
            let success = false;
            if (modoEdicion) {
                const empleadoEnEstacion = empleadoActual.datosPorEstacion && empleadoActual.datosPorEstacion[estacion.id];
                if (empleadoEnEstacion) {
                    success = await ActualizarEmpleado(estacion.endpoint, { ...empleadoActual, id: empleadoEnEstacion.id });
                }
            } else {
                success = await CrearEmpleado(estacion.endpoint, empleadoActual);
            }

            if (success) {
                remoteSuccessCount++;
            } else {
                remoteErrors.push(estacion.nombre);
            }
        }

        // 2. Check Remote Results and Prompt for Local if needed
        let proceedWithLocal = true;
        if (remoteErrors.length > 0) {
            StopCargando();
            const result = await Swal.fire({
                title: 'Error en estaciones remotas',
                text: `Falló en: ${remoteErrors.join(', ')}. ¿Desea continuar con la estación local?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Cancelar'
            });
            proceedWithLocal = result.isConfirmed;
            if (proceedWithLocal) StartCargando("Guardando en local...");
        }

        // 3. Process Local Station
        let localSuccess = false;
        if (proceedWithLocal && localStation) {
            if (modoEdicion) {
                const empleadoEnEstacion = empleadoActual.datosPorEstacion && empleadoActual.datosPorEstacion[localStation.id];
                if (empleadoEnEstacion) {
                    localSuccess = await ActualizarEmpleado(localStation.endpoint, { ...empleadoActual, id: empleadoEnEstacion.id });
                }
            } else {
                localSuccess = await CrearEmpleado(localStation.endpoint, empleadoActual);
            }
        }

        StopCargando();

        if (remoteSuccessCount > 0 || localSuccess) {
            Swal.fire('Éxito', `Operación realizada. Remotos: ${remoteSuccessCount}, Local: ${localSuccess ? 'Sí' : 'No'}.`, 'success');
            handleClose();
            cargarEmpleadosDeTodas(estaciones);
        } else if (!proceedWithLocal && remoteErrors.length > 0) {
            // User cancelled
        } else {
            Swal.fire('Error', 'No se pudo guardar en ninguna estación', 'error');
        }
    };

    const handleSincronizar = async (empleado, estacionDestino) => {
        StartCargando(`Sincronizando en ${estacionDestino.nombre}...`);
        const { id, datosPorEstacion, estacionesEncontradas, faltanteEn, ...datosEmpleado } = empleado;

        const { value: password } = await Swal.fire({
            title: 'Ingrese contraseña para el nuevo empleado',
            input: 'password',
            inputLabel: 'Contraseña',
            inputPlaceholder: 'Ingrese contraseña',
            inputAttributes: {
                minlength: 6,
                autocapitalize: 'off',
                autocorrect: 'off'
            },
            showCancelButton: true
        });

        if (password) {
            const success = await CrearEmpleado(estacionDestino.endpoint, { ...datosEmpleado, password });
            StopCargando();
            if (success) {
                Swal.fire('Sincronizado', 'Empleado creado en ' + estacionDestino.nombre, 'success');
                cargarEmpleadosDeTodas(estaciones);
            }
        } else {
            StopCargando();
        }
    };

    const handleEditar = (empleado) => {
        setEmpleadoActual(empleado);
        setModoEdicion(true);
        handleShow();
    };

    const handleEliminar = (empleado) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Se eliminará de TODAS las estaciones donde existe.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");

                const localStation = estaciones.find(e => e.local);
                const remoteStations = estaciones.filter(e => !e.local);

                let remoteSuccessCount = 0;
                let remoteErrors = [];

                // 1. Remote
                for (const estacion of remoteStations) {
                    if (empleado.estacionesEncontradas.includes(estacion.id)) {
                        const empleadoEnEstacion = empleado.datosPorEstacion[estacion.id];
                        const success = await EliminarEmpleado(estacion.endpoint, { id: empleadoEnEstacion.id });
                        if (success) remoteSuccessCount++;
                        else remoteErrors.push(estacion.nombre);
                    }
                }

                // 2. Check Remote & Prompt
                let proceedWithLocal = true;
                if (remoteErrors.length > 0) {
                    StopCargando();
                    const result = await Swal.fire({
                        title: 'Error en estaciones remotas',
                        text: `Falló al eliminar en: ${remoteErrors.join(', ')}. ¿Desea continuar con la estación local?`,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, continuar',
                        cancelButtonText: 'Cancelar'
                    });
                    proceedWithLocal = result.isConfirmed;
                    if (proceedWithLocal) StartCargando("Eliminando en local...");
                }

                // 3. Local
                let localSuccess = false;
                if (proceedWithLocal && localStation && empleado.estacionesEncontradas.includes(localStation.id)) {
                    const empleadoEnEstacion = empleado.datosPorEstacion[localStation.id];
                    localSuccess = await EliminarEmpleado(localStation.endpoint, { id: empleadoEnEstacion.id });
                }

                StopCargando();
                if (remoteSuccessCount > 0 || localSuccess) {
                    Swal.fire('Eliminado!', `Empleado eliminado. Remotos: ${remoteSuccessCount}, Local: ${localSuccess ? 'Sí' : 'No'}.`, 'success');
                    cargarEmpleadosDeTodas(estaciones);
                }
            }
        })
    };

    const handlePassModal = (empleado) => {
        setPassData({ empleado: empleado, password: "" });
        setShowPassModal(true);
    };

    const handleGuardarPass = async (e) => {
        e.preventDefault();
        StartCargando("Cambiando contraseña...");
        const empleado = passData.empleado;

        const localStation = estaciones.find(e => e.local);
        const remoteStations = estaciones.filter(e => !e.local);

        let remoteSuccessCount = 0;
        let remoteErrors = [];

        // 1. Remote
        for (const estacion of remoteStations) {
            if (empleado.estacionesEncontradas.includes(estacion.id)) {
                const empleadoEnEstacion = empleado.datosPorEstacion[estacion.id];
                const success = await CambiarPasswordEmpleado(estacion.endpoint, { id: empleadoEnEstacion.id, password: passData.password });
                if (success) remoteSuccessCount++;
                else remoteErrors.push(estacion.nombre);
            }
        }

        // 2. Check Remote & Prompt
        let proceedWithLocal = true;
        if (remoteErrors.length > 0) {
            StopCargando();
            const result = await Swal.fire({
                title: 'Error en estaciones remotas',
                text: `Falló al cambiar password en: ${remoteErrors.join(', ')}. ¿Desea continuar con la estación local?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Cancelar'
            });
            proceedWithLocal = result.isConfirmed;
            if (proceedWithLocal) StartCargando("Cambiando password en local...");
        }

        // 3. Local
        let localSuccess = false;
        if (proceedWithLocal && localStation && empleado.estacionesEncontradas.includes(localStation.id)) {
            const empleadoEnEstacion = empleado.datosPorEstacion[localStation.id];
            localSuccess = await CambiarPasswordEmpleado(localStation.endpoint, { id: empleadoEnEstacion.id, password: passData.password });
        }

        StopCargando();
        if (remoteSuccessCount > 0 || localSuccess) {
            Swal.fire('Éxito', `Contraseña actualizada. Remotos: ${remoteSuccessCount}, Local: ${localSuccess ? 'Sí' : 'No'}.`, 'success');
            setShowPassModal(false);
        }
    };

    const handlePermissionsModal = (empleado) => {
        setEmpleadoActual({ ...empleado }); // Load current permissions
        setShowPermissionsModal(true);
    };

    const handlePermissionChange = (perm) => {
        setEmpleadoActual(prev => ({
            ...prev,
            [perm]: !prev[perm]
        }));
    };

    const handleSavePermissions = async () => {
        // Permissions are part of the employee object, so we update the employee
        // We reuse the update logic but just for permissions? Or full update?
        // Let's do a full update for simplicity using handleGuardarEmpleado logic but triggered manually

        // We need to trigger the update process. Since handleGuardarEmpleado expects an event, we can adapt it or call the update logic directly.
        // For now, let's just call handleGuardarEmpleado with a fake event.
        const fakeEvent = { preventDefault: () => { } };
        await handleGuardarEmpleado(fakeEvent);
        setShowPermissionsModal(false);
    };

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (name) => {
        if (sortConfig.key !== name) {
            return <FaSort className="ms-1 text-muted" size={12} />;
        }
        if (sortConfig.direction === 'ascending') {
            return <FaSortUp className="ms-1" size={12} />;
        }
        return <FaSortDown className="ms-1" size={12} />;
    };

    const empleadosFiltrados = React.useMemo(() => {
        let items = [...empleadosUnificados];

        // Filter
        if (busqueda) {
            const termino = busqueda.toLowerCase();
            items = items.filter(empleado =>
                empleado.nombre.toLowerCase().includes(termino) ||
                empleado.cuil.toLowerCase().includes(termino) ||
                empleado.email.toLowerCase().includes(termino)
            );
        }

        // Sort
        if (sortConfig.key) {
            items.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }

        return items;
    }, [empleadosUnificados, busqueda, sortConfig]);

    return (
        <div className="container-fluid py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>Gestión de Empleados</h3>
                <Button variant="primary" onClick={handleShow}>
                    <FaPlus /> Agregar Empleado Global
                </Button>
            </div>

            <div className="card shadow-sm p-4">
                <div className="mb-4 d-flex ">
                    <div className="input-group flex-nowrap" style={{ maxWidth: '500px' }}>
                        <Form.Control
                            type="text"
                            placeholder="Buscar por nombre, CUIL o email..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                            className='buscador'
                        />
                    </div>
                </div>

                <Table striped bordered hover responsive>
                    <thead className="bg-light">
                        <tr>
                            <th onClick={() => requestSort('nombre')} style={{ cursor: 'pointer' }}>
                                Nombre {getSortIcon('nombre')}
                            </th>
                            <th onClick={() => requestSort('dni')} style={{ cursor: 'pointer' }}>
                                CUIL/DNI {getSortIcon('dni')}
                            </th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {empleadosFiltrados.map(empleado => (
                            <tr key={empleado.dni || empleado.cuil || empleado.email}>
                                <td>{empleado.nombre} {empleado.apellido}</td>
                                <td>{empleado.dni}</td>
                                <td>
                                    {empleado.faltanteEn.length > 0 ? (
                                        <div>
                                            <span className="text-warning fw-bold">Falta en:</span>
                                            <ul className="mb-0 ps-3">
                                                {empleado.faltanteEn.map(e => (
                                                    <li key={e.id} className="d-flex justify-content-between align-items-center">
                                                        <small>{e.nombre}</small>
                                                        <Button variant="outline-success" size="sm" className="py-0 px-1 ms-1" onClick={() => handleSincronizar(empleado, e)} title="Sincronizar">
                                                            <FaSync size={10} />
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ) : (
                                        <span className="text-success">Sincronizado en todas</span>
                                    )}
                                </td>
                                <td>
                                    <Button variant="warning" size="sm" className="me-1" onClick={() => handleEditar(empleado)} title="Editar Globalmente">
                                        <FaEdit />
                                    </Button>
                                    <Button variant="info" size="sm" className="me-1" onClick={() => handlePassModal(empleado)} title="Cambiar Contraseña Global">
                                        <FaKey />
                                    </Button>
                                    <Button variant="secondary" size="sm" className="me-1" onClick={() => handlePermissionsModal(empleado)} title="Gestionar Permisos">
                                        <FaUserShield />
                                    </Button>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => handleEliminar(empleado)}
                                        title="Eliminar Globalmente"
                                    >
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal Empleado */}
            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{modoEdicion ? 'Editar Empleado' : 'Nuevo Empleado'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleGuardarEmpleado}>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Nombre Completo</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.nombre} onChange={(e) => setEmpleadoActual({ ...empleadoActual, nombre: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>CUIL</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.cuil} onChange={(e) => setEmpleadoActual({ ...empleadoActual, cuil: e.target.value })} required />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Estado Civil</Form.Label>
                                    <Form.Select value={empleadoActual.estado_civil} onChange={(e) => setEmpleadoActual({ ...empleadoActual, estado_civil: e.target.value })}>
                                        <option value="">Seleccione...</option>
                                        <option value="Soltero">Soltero</option>
                                        <option value="Casado">Casado</option>
                                        <option value="Divorciado">Divorciado</option>
                                        <option value="Viudo">Viudo</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo Contrato</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.tipo_contrato} onChange={(e) => setEmpleadoActual({ ...empleadoActual, tipo_contrato: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>ART</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.art} onChange={(e) => setEmpleadoActual({ ...empleadoActual, art: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Fecha Ingreso</Form.Label>
                                    <Form.Control type="date" value={empleadoActual.fecha_ingreso} onChange={(e) => setEmpleadoActual({ ...empleadoActual, fecha_ingreso: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Vencimiento Contrato</Form.Label>
                                    <Form.Control type="date" value={empleadoActual.vencimiento_contrato} onChange={(e) => setEmpleadoActual({ ...empleadoActual, vencimiento_contrato: e.target.value })} />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Domicilio</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.domicilio} onChange={(e) => setEmpleadoActual({ ...empleadoActual, domicilio: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Código Postal</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.codigo_postal} onChange={(e) => setEmpleadoActual({ ...empleadoActual, codigo_postal: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Provincia</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.provincia} onChange={(e) => setEmpleadoActual({ ...empleadoActual, provincia: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Localidad</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.localidad} onChange={(e) => setEmpleadoActual({ ...empleadoActual, localidad: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control type="text" value={empleadoActual.telefono} onChange={(e) => setEmpleadoActual({ ...empleadoActual, telefono: e.target.value })} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" value={empleadoActual.email} onChange={(e) => setEmpleadoActual({ ...empleadoActual, email: e.target.value })} required />
                                </Form.Group>
                                {!modoEdicion && (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Contraseña</Form.Label>
                                        <Form.Control type="password" value={empleadoActual.password} onChange={(e) => setEmpleadoActual({ ...empleadoActual, password: e.target.value })} required />
                                    </Form.Group>
                                )}
                            </div>
                        </div>
                        <Button variant="primary" type="submit">
                            Guardar en Todas las Estaciones
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal Password */}
            <Modal show={showPassModal} onHide={() => setShowPassModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Cambiar Contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleGuardarPass}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nueva Contraseña</Form.Label>
                            <Form.Control type="password" value={passData.password} onChange={(e) => setPassData({ ...passData, password: e.target.value })} required />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Guardar en Todas las Estaciones
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal Permisos */}
            <Modal show={showPermissionsModal} onHide={() => setShowPermissionsModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Gestionar Permisos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Check
                            type="switch"
                            id="perm-playa"
                            label="Habilitación Playa y/o Minimercado"
                            checked={empleadoActual.permiso_playa_minimercado}
                            onChange={() => handlePermissionChange('permiso_playa_minimercado')}
                            className="mb-2"
                        />
                        <Form.Check
                            type="switch"
                            id="perm-vencidos"
                            label="Puede facturar despachos vencidos"
                            checked={empleadoActual.permiso_facturar_vencidos}
                            onChange={() => handlePermissionChange('permiso_facturar_vencidos')}
                            className="mb-2"
                        />
                        <Form.Check
                            type="switch"
                            id="perm-moviles"
                            label="Permitir alta de móviles a clientes"
                            checked={empleadoActual.permiso_alta_moviles}
                            onChange={() => handlePermissionChange('permiso_alta_moviles')}
                            className="mb-2"
                        />
                        <Form.Check
                            type="switch"
                            id="perm-reimpresion"
                            label="Permitir reimpresión de cierre de turno"
                            checked={empleadoActual.permiso_reimpresion_cierre}
                            onChange={() => handlePermissionChange('permiso_reimpresion_cierre')}
                            className="mb-2"
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPermissionsModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSavePermissions}>
                        Guardar Permisos
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
